/** @jsxImportSource @emotion/react */

import { CSSObject } from "@emotion/react";
import { FC, useEffect, useState } from "react";
import { ColorNames } from "../../theme";
import { LatLng } from "../../types";
import Column from "../Grid/Column";
import Row from "../Grid/Row";
import Map from "../Map";
import Typography from "../Typography";
import TextInput from "./TextInput";
import useDebounce from "../../hooks/useDebounce";

interface GeoLocationInputProps {
  value: LatLng;
  label: string;
  handleChange: (latLng: LatLng) => void;
}

const styles: CSSObject = {
  mapContainer: {
    height: 270,
  },
};

const GeoLocationInput: FC<GeoLocationInputProps> = ({
  value,
  label,
  handleChange,
}) => {
  const [lat, setLat] = useState<string>(value?.lat?.toString());
  const [lng, setLng] = useState<string>(value?.lng?.toString());

  const { debouncedValue: debouncedLat } = useDebounce(lat, 500);
  const { debouncedValue: debouncedLng } = useDebounce(lng, 500);

  const handleMapClick = (event: google.maps.MapMouseEvent) => {
    const { latLng } = event;
    handleChange({
      lat: latLng!.lat(),
      lng: latLng!.lng(),
    });
    setLat(latLng!.lat().toString());
    setLng(latLng!.lng().toString());
  };

  useEffect(() => {
    handleChange({
      lat: parseFloat(debouncedLat),
      lng: parseFloat(debouncedLng),
    });
  }, [debouncedLat, debouncedLng]);

  return (
    <>
      <Row>
        <Column xs={6} sm={4}>
          <Typography
            variant="textMedium"
            component="div"
            color={ColorNames.GREEN}
            align="left"
          >
            {`SUL latitude`}
          </Typography>
          <TextInput
            placeholder={"GPS"}
            value={lat?.toString()}
            onChange={(e) => setLat(e.target.value)}
          ></TextInput>
        </Column>
        <Column xs={6} sm={4}>
          <Typography
            variant="textMedium"
            component="div"
            color={ColorNames.GREEN}
            align="left"
          >
            {`OESTE longitude`}
          </Typography>
          <TextInput
            placeholder={"GPS"}
            value={lng?.toString()}
            onChange={(e) => setLng(e.target.value)}
          ></TextInput>
          {/* </Row> */}
        </Column>
      </Row>
      <Row>
        <Column>
          <Typography
            variant="textMedium"
            component="div"
            color={ColorNames.GREEN}
            align="left"
          >
            {`Clique na localização da ${label}`}
          </Typography>
        </Column>
        <Column xs={12} css={styles.mapContainer}>
          <Map
            center={value && value.lat ? value : { lat: -23, lng: -45 }}
            onClick={handleMapClick}
            markers={value ? [value] : []}
          />
        </Column>
      </Row>
    </>
  );
};

export default GeoLocationInput;
